import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

/***    ANGULAR MATERIAL IMPORT    ***/
// animations

// components
import {
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatTableModule,
    MatCardModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatDialogModule, MatExpansionModule, MatFormFieldModule,
    MatInputModule, MatSlideToggleModule, MatSortModule, MatGridListModule, MatChipsModule, MatTabsModule, MatRadioModule,
    MatDatepickerModule, MatSelectModule,
} from '@angular/material';
/***    ANGULAR MATERIAL IMPORT    ***/

import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PipesModule} from '../pipes/pipes.module';
import {CustomersListComponent} from './CustomersListComponent/customers-list.component';
import {CustomerDeleteConfirmDialogComponent} from './CustomerDeleteConfirmDialogComponent/customer-delete-confirm.dialog.component';
import {CustomerService} from '../services/customer.service';
import {CustomerEditComponent} from './CustomerEditComponent/customer-edit.component';
import {CustomerDetailComponent} from './CustomerDetailComponent/customer-detail.component';
import {CustomerContactPersonsListComponent} from './CustomerContactPersonsListComponent/customer-contact-persons-list.component';
import {CustomerContactPersonService} from '../services/customer-contact-person.service';
import {AresService} from '../services/ares.service';
import {CustomerContactPersonDialogComponent} from './CustomerContactPersonDialogComponent/customer-contact-person.dialog.component';
import {CustomerContactPersonDeleteConfirmDialogComponent} from './CustomerContactPersonDeleteConfirmDialogComponent/customer-contact-person-delete-confirm.dialog.component';
import {ContractsModule} from '../ContractsModule/contracts.module';
import {CustomersStatsDialogComponent} from './CustomersStatsDialogComponent/customers-stats.dialog.component';
import {DocumentsModule} from '../DocumentsModule/documents.module';
import {CustomerAresComparisonDialogComponent} from './CustomerAresComparisonDialogComponent/customer-ares-comparison.dialog.component';

@NgModule({
    declarations: [
        CustomersListComponent,
        CustomerDetailComponent,
        CustomerEditComponent,
        CustomerDeleteConfirmDialogComponent,
        CustomerContactPersonsListComponent,
        CustomerContactPersonDialogComponent,
        CustomerContactPersonDeleteConfirmDialogComponent,
        CustomersStatsDialogComponent,
        CustomerAresComparisonDialogComponent
    ],
    imports: [
        BrowserModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        DocumentsModule,

        // Angular Material components
        MatButtonModule,
        MatCardModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSlideToggleModule,
        MatSortModule,
        MatTableModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,

        ContractsModule,
        PipesModule,
    ],
    exports: [
        CustomerContactPersonsListComponent,
        CustomerAresComparisonDialogComponent
    ],
    entryComponents: [
        CustomerDeleteConfirmDialogComponent,
        CustomerContactPersonDialogComponent,
        CustomerContactPersonDeleteConfirmDialogComponent,
        CustomersStatsDialogComponent,
        CustomerAresComparisonDialogComponent
    ],
    providers: [
        CustomerService,
        CustomerContactPersonService,
        AresService
    ]
})
export class CustomersModule {
}



// WEBPACK FOOTER //
// /app/src/CustomersModule/customers.module.ts